function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExtendableError = function (_Error) {
  _inherits(ExtendableError, _Error);

  function ExtendableError(msg) {
    _classCallCheck(this, ExtendableError);

    var _this = _possibleConstructorReturn(this, _Error.call(this, msg));

    _this.name = _this.constructor.name;
    _this.message = msg;
    _this.stack = new Error(msg).stack;
    return _this;
  }

  return ExtendableError;
}(Error);

exports.InvalidParameterError = function (_ExtendableError) {
  _inherits(InvalidParameterError, _ExtendableError);

  function InvalidParameterError(msg) {
    _classCallCheck(this, InvalidParameterError);

    return _possibleConstructorReturn(this, _ExtendableError.call(this, msg));
  }

  return InvalidParameterError;
}(ExtendableError);

exports.MalformedAstError = function (_ExtendableError2) {
  _inherits(MalformedAstError, _ExtendableError2);

  function MalformedAstError(msg) {
    _classCallCheck(this, MalformedAstError);

    return _possibleConstructorReturn(this, _ExtendableError2.call(this, msg));
  }

  return MalformedAstError;
}(ExtendableError);